<template>
    <!-- pagina da aprire dopo aver aperto il portale esterno di un partner in convenzione -->
    <!-- per essere riportati alla home e non dover tornare indietro manualmente -->
    <b-card class="mr-1 ml-1 mt-2">
      <b-row>
        <b-col class="text-center">
          <p class="h4 mb-3">{{page_title}}</p>
          <p class="h5">Ti ringraziamo per aver visitato i nostri partner.</p>
          <p>Verrai reindirizzato automaticamente alla home tra {{seconds_to_go}} secondi, oppure clicca qui sotto.</p>
          <b-button pill class="mt-1" variant="primary" :to="{ name : 'menu' }">Torna alla home</b-button>
        </b-col>
      </b-row>
    </b-card>
</template>

<script>
export default {
  name: 'ConvRedirect',
  data () {
    return {

      // Secondi da aspettare prima di tornare alla home
      seconds_to_go : 10,
      // Variabile per ospitare il timer.
      timer : null
    }
  },
  methods: {
    /**
     * Funzione richiamata dal timer che scala i secondi
     */
    scala_secondi : function () {
      this.seconds_to_go -= 1;
    }
  },
  watch: {
    /**
     * Quando i secondi sono stati scalati tutti e sono sotto lo zero
     * allora torniamo alla home.
     */
    seconds_to_go : function ( val ){
      if ( val < 0 ) {
        clearInterval( this.timer );
        // Usiamo replace, non ci serve di avere questa pagina nella history
        // usiamo quindi replace.
        this.$router.replace( { name : 'menu' } );
      }
    }
  },
  /**
   * Entrando nella pagina facciamo partire un conteggio che
   * dopo N secondi ci riporta in automatico al menù principale.
   */
  created : function () {
    console.log( this.page_title );
    this.timer = setInterval( this.scala_secondi, 1000 );
  },
  props : {
    /**
     * Titolo da mostrare nella pagina.
     */
    page_title: {
        type: String,
        default: null
    }
  }
}
</script>

<style scoped></style>